export default __webpack_public_path__ + "static/media/double-rope-border-left.8cbd1e68.svg";